declare global {
  interface Window {
    Paddle?: any;
  }
}

const PADDLE_ENV = import.meta.env.VITE_PADDLE_ENVIRONMENT || 'sandbox';
const PADDLE_CLIENT_TOKEN = import.meta.env.VITE_PADDLE_CLIENT_TOKEN || '';

let initialized = false;
let onCheckoutComplete: (() => void) | null = null;

export function initPaddle() {
  if (initialized || !window.Paddle || !PADDLE_CLIENT_TOKEN) return;

  if (PADDLE_ENV === 'sandbox') {
    window.Paddle.Environment.set('sandbox');
  }

  window.Paddle.Initialize({
    token: PADDLE_CLIENT_TOKEN,
    eventCallback: (event: any) => {
      if (event.name === 'checkout.completed') {
        // Checkout succeeded — trigger the callback after a short delay
        // to give the webhook time to update the plan
        if (onCheckoutComplete) {
          setTimeout(onCheckoutComplete, 3000);
        }
      }
    },
  });

  initialized = true;
}

export interface CheckoutOptions {
  priceId: string;
  userId: string;
  email: string;
  customerId?: string;
  quantity?: number;
  onSuccess?: () => void;
}

export function openCheckout({ priceId, userId, email, customerId, quantity = 1, onSuccess }: CheckoutOptions) {
  if (!window.Paddle) {
    console.error('Paddle.js not loaded');
    return;
  }

  initPaddle();

  // Register the success callback
  onCheckoutComplete = onSuccess || null;

  const checkoutSettings: any = {
    items: [{ priceId, quantity }],
    customer: customerId ? { id: customerId } : { email },
    customData: { userId },
    settings: {
      allowLogout: false,
    },
  };

  window.Paddle.Checkout.open(checkoutSettings);
}
